import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#F1F4FA"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M93.566 88.54a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
      clipRule="evenodd"
    />
    <path
      fill="#C7D0D9"
      d="M101.5 34.373a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M16.415 53.793a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M17.62 68.54a1.5 1.5 0 0 1 0 2.122l-9.993 9.994a1.5 1.5 0 1 1-2.122-2.121L15.5 68.54a1.5 1.5 0 0 1 2.122 0"
      clipRule="evenodd"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M5.505 68.54a1.5 1.5 0 0 1 2.122 0l9.994 9.995a1.5 1.5 0 1 1-2.122 2.121l-9.994-9.994a1.5 1.5 0 0 1 0-2.121M105.633 44.473a1.5 1.5 0 0 1 1.5 1.5v14.133a1.5 1.5 0 0 1-3 0V45.973a1.5 1.5 0 0 1 1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M97.066 53.04a1.5 1.5 0 0 1 1.5-1.5H112.7a1.5 1.5 0 0 1 0 3H98.566a1.5 1.5 0 0 1-1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#C7D0D9"
      d="M57.996 26a31.603 31.603 0 0 0-26.879 48.302L24.22 88.79c-.8 1.68.954 3.433 2.634 2.633l14.487-6.9c13.446 8.363 31.39 5.645 41.703-7.424 5.064-6.417 7.422-14.7 6.498-22.823C87.66 37.732 73.834 25.97 57.997 26"
    />
    <path
      fill="#7B8493"
      fillRule="evenodd"
      d="M44.32 50.136a2.25 2.25 0 0 1 2.25-2.25h24.836a2.25 2.25 0 0 1 0 4.5H46.57a2.25 2.25 0 0 1-2.25-2.25M44.32 63.523a2.25 2.25 0 0 1 2.25-2.25h18.084a2.25 2.25 0 0 1 0 4.5H46.57a2.25 2.25 0 0 1-2.25-2.25"
      clipRule="evenodd"
    />
  </svg>
);
const SvgEnrichedIconCommentsGreyscale = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconCommentsGreyscale);
export default Memo;
